/**
 * - Changed layout from `DoubleStack` to `Aside`
 * - Added `AccountBreadcrumbs` and `AccountWelcome` widgets to the `first` slot
 */

import { Layout } from '@/data/types/Layout';

export const getAccountPage = (): Layout => ({
	name: 'Aside',
	slots: {
		header: [{ name: 'Header', id: 'header' }],
		first: [
			{ name: 'AccountBreadcrumbs', id: 'account-breadcrumbs' },
			{ name: 'AccountWelcome', id: 'account-welcome' },
		],
		aside: [{ name: 'AccountSidebar', id: 'account-sidebar' }],
		second: [{ name: 'Account', id: 'account' }],
		footer: [{ name: 'Footer', id: 'footer' }],
	},
});
